module.exports = __webpack_public_path__ + "static/media/whatsapp.7cca2160.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/whatsapp.png
// module id = 642
// module chunks = 0